import { z } from 'zod';
export const JobType = z.enum(['scan', 'content_pack', 'scaffold', 'ai_home']);
/** Job types that never touch a package entitlement. See packages-catalog.md. */
export const FREE_JOB_TYPES = [
    'scan',
    'content_pack',
    'scaffold',
];
export function isFreeJobType(type) {
    return FREE_JOB_TYPES.includes(type);
}
export const JobStatus = z.enum(['queued', 'claimed', 'running', 'succeeded', 'failed', 'canceled']);
export const TERMINAL_JOB_STATUSES = ['succeeded', 'failed', 'canceled'];
export function isTerminalStatus(status) {
    return TERMINAL_JOB_STATUSES.includes(status);
}
export const ArtifactKind = z.enum([
    'content_pack_zip',
    'scaffold_zip',
    'ai_zip',
    'ir_json',
    'report_md',
    'screenshots_zip',
    'build_log',
]);
export const PackageId = z.enum(['package_starter', 'package_growth', 'package_large']);
export const ErrorCode = z.enum([
    'UNAUTHORIZED',
    'FORBIDDEN',
    'NOT_FOUND',
    'VALIDATION',
    'PACKAGE_INSUFFICIENT',
    'FRAMER_AUTH',
    'FRAMER_PROJECT',
    'FRAMER_RATE',
    'FRAMER_PARTIAL',
    'JOB_CONFLICT',
    'PRECONDITION_FAILED',
    'BUILD_FAILED',
    'AI_BUDGET_EXCEEDED',
    'TIMEOUT',
    'INTERNAL',
    'RUNNER_UNAUTHORIZED',
    'LEASE_INVALID',
    'RATE_LIMITED',
]);
export const ApiError = z.object({
    error: z.object({
        code: ErrorCode,
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
/** HTTP status used when an error code surfaces as a failed request (not as job state). */
export const ERROR_HTTP_STATUS = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    VALIDATION: 422,
    PACKAGE_INSUFFICIENT: 402,
    FRAMER_AUTH: 502,
    FRAMER_PROJECT: 502,
    FRAMER_RATE: 503,
    FRAMER_PARTIAL: 200,
    JOB_CONFLICT: 409,
    PRECONDITION_FAILED: 412,
    BUILD_FAILED: 200,
    AI_BUDGET_EXCEEDED: 200,
    TIMEOUT: 200,
    INTERNAL: 500,
    RUNNER_UNAUTHORIZED: 401,
    LEASE_INVALID: 409,
    RATE_LIMITED: 429,
};
export const Uuid = z.string().uuid();
export const IsoDateTime = z.string().datetime();
//# sourceMappingURL=primitives.js.map